/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail,
    ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailFromJSON,
    ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailToJSON,
    ControlcenterMelcoModelsError,
    ControlcenterMelcoModelsErrorFromJSON,
    ControlcenterMelcoModelsErrorToJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemFromJSON,
    ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemToJSON,
} from '../models';

export interface DigitizingOrdersApiDigitizingOrdersGetDetailRequest {
    id: string;
}

export interface DigitizingOrdersApiDigitizingOrdersGetListRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    orderStatusList?: string;
    vendorId?: string;
}

/**
 * 
 */
export class DigitizingOrdersApi extends runtime.BaseAPI {

    /**
     */
    async digitizingOrdersGetDetailRaw(requestParameters: DigitizingOrdersApiDigitizingOrdersGetDetailRequest): Promise<runtime.ApiResponse<ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling digitizingOrdersGetDetail.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/digitize/orders/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetailFromJSON(jsonValue));
    }

    /**
     */
    async digitizingOrdersGetDetail(requestParameters: DigitizingOrdersApiDigitizingOrdersGetDetailRequest): Promise<ControlcenterMelcoControlCenterModelsDigitizingOrderSupportDetail> {
        const response = await this.digitizingOrdersGetDetailRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async digitizingOrdersGetListRaw(requestParameters: DigitizingOrdersApiDigitizingOrdersGetListRequest): Promise<runtime.ApiResponse<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.orderStatusList !== undefined) {
            queryParameters['order_status_list'] = requestParameters.orderStatusList;
        }

        if (requestParameters.vendorId !== undefined) {
            queryParameters['vendor_id'] = requestParameters.vendorId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/manage/digitize/orders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItemFromJSON(jsonValue));
    }

    /**
     */
    async digitizingOrdersGetList(requestParameters: DigitizingOrdersApiDigitizingOrdersGetListRequest): Promise<ControlcenterMelcoModelsGenericList1MelcoControlCenterModelsDigitizingOrderListItem> {
        const response = await this.digitizingOrdersGetListRaw(requestParameters);
        return await response.value();
    }

}
